<template>
  <span>
    <a @click="showModal">指定分销</a>
    <a-modal
      okText="保存"
      :visible='modalVisible'
      :confirmLoading='submitLoading'
      @ok="submitEvent"
      @cancel="cancelEvent"
    >
      <div class="card-title">平台伙伴</div>
      <div class="detail-box">
        <a-checkbox-group v-model="platform_distribution_id_list">
          <a-checkbox v-for="(item, index) in platform_partnerDto_list" :key="index" :value="item.partner_id">
              {{ item.partner_name }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
      <div class="card-title">云仓伙伴</div>
      <div class="detail-box">
        <a-checkbox-group v-model="cloud_distribution_id_list">
          <a-checkbox v-for="(item, index) in cloud_partnerDto_list" :key="index" :value="item.partner_id">
              {{ item.partner_name }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </a-modal>
  </span>
</template>

<script>

export default {
  name: 'AppointDistribution',
  props: {
    dataObj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      modalVisible: false,
      submitLoading: false,
      catalogId: this.$route.query.catalogId,
      proId: this.$route.query.proId,
      optionDistributionDetail: {},
      platform_partnerDto_list: [],
      platform_distribution_id_list: [],
      cloud_partnerDto_list: [],
      cloud_distribution_id_list: []
    }
  },
  methods: {
    async showModal() {
      this.optionDistributionDetail = {}
      this.platform_partnerDto_list = []
      this.platform_distribution_id_list = []
      this.cloud_partnerDto_list = []
      this.cloud_distribution_id_list = []
      await this.getOptionDistributionDetail()
      this.modalVisible = true
    },
    cancelEvent() {
      this.modalVisible = false
    },
    getOptionDistributionDetail() { // 获取套餐分销信息
      return new Promise(resolve => {
        this.getHttpServices().getProService().post('product/optionDistribution/getOptionDistributionDetail', {
          optionId: this.dataObj.ratePlanOptionId,
          productCategoryId: this.catalogId,
          ratePlanId: this.catalogId == 2 ? this.dataObj.optionId : undefined
        }).then(res => {
          this.optionDistributionDetail = res
          this.platform_partnerDto_list = res.platform_partnerDto_list
          if (res.platform_partnerDto_list && res.platform_partnerDto_list.length) {
            this.platform_distribution_id_list = res.platform_partnerDto_list.filter(item => item.selected_type).map(item => item.partner_id)
          }
          this.cloud_partnerDto_list = res.cloud_partnerDto_list
          if (res.cloud_partnerDto_list && res.cloud_partnerDto_list.length) {
            this.cloud_distribution_id_list = res.cloud_partnerDto_list.filter(item => item.selected_type).map(item => item.partner_id)
          }
          resolve()
        }).catch(reason => {
          this.showNetWorkErrorMessage(reason)
        })
      })
    },
    submitEvent() {
      if (!this.submitLoading) {
        this.submitLoading = true
        this.getHttpServices().getProService().post('product/optionDistribution/saveOrUpdateOptionDistribution', {
          cloud_distribution_id_list: this.cloud_distribution_id_list,
          optionId: this.dataObj.ratePlanOptionId,
          platform_distribution_id_list: this.platform_distribution_id_list,
          proId: this.proId,
          productCategoryId: this.catalogId,
          ratePlanId: this.catalogId == 2 ? this.dataObj.optionId : undefined
        }).then(() => {
          this.$message.success('保存成功')
          this.cancelEvent()
          this.$emit('refresh')
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
}

.detail-box {
  margin: 10px;
}

::v-deep .ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0;
}
</style>
